import { ctaInteract } from './cta-interact'

export default { ctaInteract }
